import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import "ulysses/page";
import "ulysses/pubsub";

"use strict";

//var inactivity_timeout = 840000; //14 minutes
var inactivity_timeout = 36000000; //600 minutes

var logout_timeout = 60000; //1 minutes
var inactivity_prompt = null;
var logout = null;
var keep_alive_timeout = null;

function start_keep_alive_timeout() {
    if (keep_alive_timeout) {
        clearTimeout(keep_alive_timeout);
        keep_alive_timeout = null;
    }
    keep_alive_timeout = setInterval(function() {
        uly.api.start().follow("uly:app");
    }, 60000);
}

function start_timeout() {
    if (uly.session_timeout) {
        clearTimeout(uly.session_timeout);
        uly.session_timeout = null;
    }
    if (uly.logout_timeout) {
        clearTimeout(uly.logout_timeout);
        uly.logout_timeout = null;
    }
    if (inactivity_timeout) {
        uly.session_timeout = setTimeout(function() {
            if (logout_timeout <= 0) {
                logout();
            }
            else {
                start_logout_timeout();
            }
        }, inactivity_timeout);
    }
}

function start_logout_timeout() {
    if (uly.session_timeout) {
        clearTimeout(uly.session_timeout);
        uly.session_timeout = null;
    }
    if (uly.logout_timeout) {
        clearTimeout(uly.logout_timeout);
        uly.logout_timeout = null;
    }

    var done = false;
    var logout_prompt = null;
    if (inactivity_prompt) {
        logout_prompt = inactivity_prompt(logout_timeout).then(function() {
            start_timeout();
        }).fail(function() {
            if (!done) {
                logout();
                done = true;
            }
        });
    }
    if (logout_timeout) {
        uly.logout_timeout = setTimeout(function() {
            if (logout_prompt)
                logout_prompt.reject();
            if (!done) {
                logout();
                done = true;
            }
        }, logout_timeout);
    }
    else
        logout();

}

$.extend(uly, {
    initialise_timeout: function initialise_timeout(inactivity_callback, logout_callback, i_timeout, l_timeout) {
        inactivity_timeout = i_timeout || inactivity_timeout;
        logout_timeout = (l_timeout === 0 || l_timeout) ? l_timeout : logout_timeout;
        inactivity_prompt = inactivity_callback;
        logout = logout_callback;

        start_keep_alive_timeout();

        start_timeout();
    },
    reset_timeout: function() {
        start_timeout();
    },
    cancel_timeout: function() {
        if (uly.session_timeout) {
            clearTimeout(uly.session_timeout);
            uly.session_timeout = null;
        }
        if (uly.logout_timeout) {
            clearTimeout(uly.logout_timeout);
            uly.logout_timeout = null;
        }
    }
});
